import { AlertTriangle } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

const NON_STANDARD_SHAPE_HINT =
  "This shape type isn't one of the standard module types. Remap to a standard type."

/** Amber flag for a sofa type outside the picker's featured families. */
export function NonStandardShapeBadge() {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge className="gap-1 whitespace-nowrap bg-amber-100 text-[10px] font-medium text-amber-900 hover:bg-amber-100">
            <AlertTriangle className="h-3 w-3" />
            Not in standard list
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          {NON_STANDARD_SHAPE_HINT}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

/** Inline warning block for forms (e.g. under a shape type picker). */
export function NonStandardShapeNotice({ type }: { type: string }) {
  return (
    <div className="flex items-start gap-2 rounded border border-amber-300 bg-amber-50 p-2 text-xs text-amber-900">
      <AlertTriangle className="mt-0.5 h-3.5 w-3.5 flex-shrink-0" />
      <span>
        <span className="font-mono">{type}</span> is not in the standard list.{' '}
        {NON_STANDARD_SHAPE_HINT}
      </span>
    </div>
  )
}
